import { TemplateDownloadButton } from '@/activityLog/common/Templates/TemplateDownloadButton.tsx';
import { useTranslation } from 'react-i18next';
import MenuItem from '@mui/material/MenuItem';
import { useMutation } from '@tanstack/react-query';
import {
  downloadProductsManagementTemplate,
  PRODUCTS_MANAGEMENT_TEMPLATES,
} from '@/activityLog/productsManagement/productManagementApi/productsManagementApi.ts';
import { productsManagementQueries } from '@/activityLog/productsManagement/queries/productsManagementQueries.ts';
import { useIsCslUser } from 'auth/hooks/useIsCslUser.ts';

export const ProductsManagementTemplateDownloadButton = () => {
  const { t } = useTranslation();
  const isCslUser = useIsCslUser();

  const { mutate: downloadTemplate, isPending } = useMutation({
    mutationKey: productsManagementQueries.downloadTemplate,
    mutationFn: () =>
      downloadProductsManagementTemplate(
        isCslUser ? PRODUCTS_MANAGEMENT_TEMPLATES.INTERNAL : PRODUCTS_MANAGEMENT_TEMPLATES.CUSTOMER,
      ),
  });

  return (
    <TemplateDownloadButton>
      <MenuItem
        key={'productManagementTemplate'}
        disabled={isPending}
        onClick={() => downloadTemplate()}
      >
        {t('activityLog.productsManagement.template.productsManagementTemplate')}
      </MenuItem>
    </TemplateDownloadButton>
  );
};
